/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 *
 *	GeoIP provided by ipgeolocation.io
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


    // Toggle Socials
    // $( "#socialShare" ).click(function() {
    //   $('#social').fadeToggle();
    // });

    //
    // Scoll for bbrand pages
    $('a[href*=\\#]:not([href=\\#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
        && location.hostname == this.hostname) {
            var $target = $(this.hash);
            $target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
            if ($target.length) {
                var targetOffset = $target.offset().top - 90;
                $('html,body').animate({scrollTop: targetOffset}, 1000);
                return false;
            }
        }
    });

    // *only* if we have anchor on the url
    if(window.location.hash) {

      var offset = -90;

      // smooth scroll to the anchor id
      $('html, body').animate({
          scrollTop: ($(window.location.hash).offset().top + offset) + 'px'
      }, 10, 'swing');
    }


    // $(".primary-nav-right .Heading, .primary-nav-left .Heading" ).mouseleave(function() {
      $(".Header__FlexItem.Header__FlexItem--fill" ).mouseenter(function() {

      // if ($(".is-expanded").length > 0 ){
        $(".Header__MainNav li.HorizontalList__Item" ).each(function() {
          $(this).removeClass('is-active');
          $(this).removeClass('is-expanded');
          //$('.Header__LinkSpacer::after').css('opacity','0');
        });

        $('.Header__MainNav .MegaMenu').each(function (item) {
          $(this).attr('aria-hidden', 'true');
        });

        // Search
        // $('.Search').attr('aria-hidden', 'true');
        // $('.Search').attr('tabindex', '');
        // $('#shopify-section-header').css('z-index', '');
        // $('html').removeClass('no-scroll');
        // $('.PageOverlay').removeClass('is-visible');

      // }
    });

    $('a[data-action="toggle-search"]').click(function() {
      setTimeout(function() {
        $('#shopify-section-header').css('z-index', '');
        $('.PageOverlay').removeClass('is-visible');
      }, 1000);
    });

    $('.Header__FlexItem.Header__FlexItem--fill .HorizontalList__Item a.Heading').click(function() {
      $('.Search').attr('aria-hidden', 'true');
      $('.Search').attr('tabindex', '');
      $('#shopify-section-header').css('z-index', '');
      $('html').removeClass('no-scroll');
      $('.PageOverlay').removeClass('is-visible');
    });


  if ($('.pdf-container').length){
    $('.pdf-container').fadeIn();
  }

  $('.ProductMeta__PriceList, .ProductForm__AddToCart, .ProductForm__QuantitySelector, .recommended').fadeIn();
